<template>
  <div>
    <div class="d-sm-none d-block" v-if="faqPage">
      <div class="head-part faq-header">
        <router-link :to="{ name: 'profile' }" class="close-cls">
          <img src="/images/svg/global/left_arrow.svg" alt="" />
        </router-link>
        <h4>{{ _T_DB(faqPage, 'content_heading') }}</h4>
      </div>
    </div>
    <section class="section-b-space faq-mobile-cls" v-if="faqPage">
      <div class="container">
        <div class="row d-none d-sm-block">
          <div class="col-sm-12">
            <div class="help-title">
              <h2>{{ _T_DB(faqPage, 'content_heading') }}</h2>
            </div>
          </div>
        </div>
        <div class="default-according" id="accordionoc">
          <div class="card" v-for="(block, index) in faqBlocks" :key="index" >
            <div class="card-header" v-b-toggle="'collapse'+index">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed txt-white">
                  {{ _T_DB(block, 'heading') }}
                </button>
              </h5>
            </div>
            <b-collapse :id="'collapse'+index">
              <div class="card-body">
                <p>
                  {{ _T_DB(block, 'text') }}
                </p>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'StaticFaq',
  props: ['searchText','pageObj'],
  computed: {
    ...mapGetters(['_T', '_T_DB', 'all_static_pages']),
    faqPage() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(page => page.type === 'faq')
      }
      return {}
    },
    faqBlocks() {
      if (this.faqPage) {
        let text = this.searchText.trim()
        if(text)
          return this.faqPage.extra_blocks.filter(e => e.text.includes(text) || e.heading.includes(text))
        else 
          return this.faqPage.extra_blocks
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.default-according {
  .card {
    border-color: rgba(198, 198, 198, 0.44);
    margin-bottom: calc(
      #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
    );
    &:last-child {
      margin-bottom: 0;
    }
    .card-header {
      background-color: $light-border;
      border-bottom: none;
      h5 {
        position: relative;
        button {
          color: $color-primary;
          padding: 8px 0;
          text-align: left;
          width: 100%;
          &:hover,
          &:focus,
          &.focus {
            text-decoration: none;
          }
          &::before {
            position: absolute;
            top: 32%;
            right: 0;
            font-size: calc(
              #{$px18} + (24 - 18) * ((100vw - #{$px320}) / (1920 - 320))
            );
            font-weight: 400;
            background-repeat: no-repeat;
            background-size: cover;
          }
          &[aria-expanded='true'] {
            &::before {
              content: '';
              background-image: url('/images/help/minus.png');
              width: $px16;
              height: $px2;
              top: 48%;
            }
          }
          &[aria-expanded='false'] {
            &::before {
              content: '';
              background-image: url('/images/help/plus.png');
              width: $px15;
              height: $px15;
            }
          }
        }
      }
    }
    .card-body {
      p {
        color: $font-color;
        margin-bottom: 0;
      }
    }
  }
}
.faq-link {
  margin-top: calc(#{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  a {
    font-weight: 600;
    font-size: calc(
      #{$px14} + (20 - 14) * ((100vw - #{$px320}) / (1920 - 320))
    );
    line-height: $px24;
    letter-spacing: 0.7px;
  }
}
.help-title {
  h2 {
    text-transform: capitalize;
    color: $brown-color;
    margin-bottom: calc(
      #{$px20} + (36 - 20) * ((100vw - #{$px320}) / (1920 - 320))
    );
    font-weight: bold;
  }
  h3 {
    font-weight: bold;
    margin-bottom: calc(
      #{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320))
    );
    margin-top: -$px7;
    span {
      font-weight: normal;
      font-size: $px18;
      line-height: $px22;
    }
  }
  &.faq-title {
    h2 {
      text-transform: uppercase;
    }
  }
}
.head-part {
  position: relative;
  padding: $px10 $px60;
  a {
    svg {
      vertical-align: middle;
    }
  }
  .close-cls {
    position: absolute;
    left: $px20;
    top: 50%;
    transform: translateY(-50%);
  }
  h4 {
    font-weight: bold;
    font-size: $px18;
    line-height: $px22;
    color: $font-color;
    text-transform: capitalize;
    margin-bottom: 0;
  }
  &.faq-header {
    border-bottom: $px1 solid $light-border;
  }
  &.only-arrow {
    padding: $px10;
    .close-cls {
      position: relative;
      left: unset;
      top: unset;
    }
  }
}
@media (max-width: 575px) {
  .faq-mobile-cls {
    padding-top: 0;
    .default-according {
      padding: $px5;
      .card {
        border: none;
        margin-bottom: 0;
        border-bottom: $px1 solid $light-border;
        .card-header {
          background-color: transparent;
          padding: 0;
          color: $color-primary;
          h5 {
            button {
              padding: $px14 0;
            }
            button[aria-expanded='false'] {
              &:before {
                background-image: url('/images/svg/global/arrow-gray.svg');
                height: $px8;
                top: 42%;
              }
            }
            button[aria-expanded='true'] {
              &:before {
                background-image: url('/images/svg/global/arrow-gray.svg');
                height: $px8;
                transform: rotate(180deg);
                top: 42%;
              }
            }
          }
        }
        .card-body {
          padding: 0 0 $px15 0;
          p {
            font-weight: normal;
            font-size: $px13;
            line-height: $px18;
            letter-spacing: 0.02em;
            color: $font-color;
          }
        }
      }
    }
  }
}
</style>
